import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '@/config/env';
import type { RootState } from '@/store';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: config.apiBaseUrl,
  prepareHeaders: (headers, { getState }) => {
    headers.set('Accept', 'application/json, text/plain, */*');

    const { token, user } = (getState() as RootState).auth;
    const resolvedToken = token ?? user?.token;
    if (resolvedToken) headers.set('Authorization', `Bearer ${resolvedToken}`);

    return headers;
  },
});

const baseQueryWithTextFallback: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (
    result.error?.status === 'PARSING_ERROR' &&
    result.error.originalStatus >= 200 &&
    result.error.originalStatus < 300
  ) {
    return { data: result.error.data };
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithTextFallback,
  tagTypes: ['Auth', 'CustomProject', 'Example', 'Ffne', 'FfnePdf', 'LeadProject'],
  endpoints: () => ({}),
});
